import { Entity } from './entity.model';

export interface OptionColor extends Entity {
  name: string;
  color: string;
}
